export function App() {
  return <main className="app" />;
}
